export const DataTypes = {
  ZIP: 'zip',
  DAT: 'dat',
  ZST: 'zst'
};

export const MODE_IMAGE = 'image';
export const MODE_DOSE = 'dose';
export const MODE_DVF = 'dvf';
export const TYPE_ACCUMULATED = 'accumulated';
export const TYPE_DELIVERED = 'delivered';